import { useConversations } from '@cascade/react/conversations';
import { useI18n } from '@cascade/react/i18n';
import { useTickets } from '@cascade/react/tickets';
import { Button, Icon, Link } from '@cascade/ui-library';
import clsx from 'clsx';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConversationList } from './conversation-list/index.ts';
import classes from './Navigation.module.scss';
import { HOME_PATH, TICKETS_PATH } from '#config/index.ts';
import { useLayout } from '#layout/Layout.context.ts';

export const Navigation = () => {
  const { translate } = useI18n();
  const { selectConversation } = useConversations();
  const { canViewTickets } = useTickets();
  const { isRail, closeSidebar } = useLayout();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isAtHomePath = pathname === HOME_PATH;
  const ticketsLabel = translate('tickets.title');

  const startNewChat = () => {
    selectConversation();
    navigate(HOME_PATH);
    closeSidebar();
  };

  return (
    <div className={clsx(classes.navigation, { [classes.rail]: isRail })}>
      <Button
        size={isRail ? 'sm' : 'md'}
        iconType='add'
        iconOnly={isRail}
        variant={isAtHomePath ? 'secondary' : 'primary'}
        label={translate('navigation.newChat')}
        className={classes.start}
        onClick={startNewChat}
      />
      {canViewTickets ? (
        <div className={classes.link}>
          <Link
            type='internal'
            variant='secondary'
            uri={`/${TICKETS_PATH}`}
            partialMatch
            iconType={isRail ? undefined : 'ticket'}
            label={
              isRail ? (
                <Icon type='ticket' size='sm' color='text-40' />
              ) : (
                ticketsLabel
              )
            }
            aria-label={isRail ? ticketsLabel : undefined}
            title={ticketsLabel}
            textProps={{ type: 'body-2' }}
          />
        </div>
      ) : null}
      {isRail ? null : <ConversationList />}
    </div>
  );
};
